import { render, staticRenderFns } from "./textEnlargement.vue?vue&type=template&id=69f5df82&"
import script from "./textEnlargement.vue?vue&type=script&lang=js&"
export * from "./textEnlargement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports